export function addDays(date: Date, days: number): Date {
    return new Date(date.setDate(date.getDate() + days));
}

export function subDays(date: Date, days: number): Date {
    return new Date(date.setDate(date.getDate() - days));
}

export function isoDateString(date: Date): string {
    return date.toISOString().slice(0, 10);
}

export function toDatetimeLocalString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes())
    );
}

export function isWithinLastMonths(date: Date | string, months: number): boolean {
    const monthInDays = 30;
    const hoursInDay = 24;
    const minutesInHour = 60;
    const secondsInMinute = 60;
    const millisecondsInSecond = 1000;

    const cutoffDate = new Date(
        Date.now() -
            months *
                monthInDays *
                hoursInDay *
                minutesInHour *
                secondsInMinute *
                millisecondsInSecond
    );
    const targetDate = new Date(date);

    return targetDate > cutoffDate;
}

export function isWeekend(date: Date): boolean {
    const day = date.getDay();
    return day === 0 || day === 6;
}

export function isWeekday(date: Date): boolean {
    return !isWeekend(date);
}

export function isToday(date: Date): boolean {
    const today = new Date();
    return date.toDateString() === today.toDateString();
}

export function isTomorrow(date: Date): boolean {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return date.toDateString() === tomorrow.toDateString();
}

export function isFriday(date: Date): boolean {
    return date.getDay() === 5;
}

export function formatDateForDisplay(date: Date): string {
    return date.toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function isVisitSpanningWeekend(visitStartDateTime: Date, visitEndDateTime: Date): boolean {
    if (visitStartDateTime.toDateString() === visitEndDateTime.toDateString()) {
        return false;
    }

    const currentDate = new Date(visitStartDateTime);
    currentDate.setHours(0, 0, 0, 0);
    const endDate = new Date(visitEndDateTime);
    endDate.setHours(0, 0, 0, 0);

    while (currentDate < endDate) {
        currentDate.setDate(currentDate.getDate() + 1);

        if (isWeekend(currentDate)) {
            return true;
        }
    }

    return false;
}

export function isVisitOverlappingWeekend(
    visitStartDateTime: Date,
    visitEndDateTime: Date
): boolean {
    if (isWeekend(visitStartDateTime) || isWeekend(visitEndDateTime)) {
        return true;
    }

    return isVisitSpanningWeekend(visitStartDateTime, visitEndDateTime);
}
